/**
 * Change styles to slider buttons.
 */
 function tarjet_button_slider_df_mobile(){
    const tabsDf = document.querySelectorAll('[data-role="tab-df-m"]'),
    tabContentsDf = document.querySelectorAll(".difference__content");

    tabsDf.forEach((tab) => {
        tab.addEventListener("click", () => {
            const tabTarget = tab.dataset.target;
            const target = document.querySelector(tabTarget);
            const active_mode = tab.dataset.mode;

            tabContentsDf.forEach((tc) => {
            tc.classList.remove("is-active");
            tc.classList.remove("is-active-inverse");
            });
            target.classList.add(active_mode);

            tabsDf.forEach((t) => {
            t.classList.remove("is-active");
            });

            let tabIcon = document.querySelector('.difference-menutabs-icons > [data-target="'+tabTarget+'"]');
            let tabText = document.querySelector('.difference-menutabs-text > [data-target="'+tabTarget+'"]');
            tabIcon.classList.add("is-active");
            tabText.classList.add("is-active");
        });
    });
}

tarjet_button_slider_df_mobile();

export default tarjet_button_slider_df_mobile;